module.exports = __webpack_public_path__ + "img/blog-single.03ea27ec.jpg";